import Vue from "vue";
import auth from "@websanova/vue-auth";
import authBearer from "./authbearer";
import httpAxios from "@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js";
import routerVueRouter from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js";

const tokenName = process.env.VUE_APP_TOKEN_NAME || '_security';

Vue.use(auth, {
  auth: authBearer,
  http: httpAxios,
  router: routerVueRouter,
  rolesKey: 'role',
  stores: ['cookie'],
  cookie: {
    Secure: process.env.VUE_APP_COOKIE_SECURE == '1' ? true : false,
    Expires: parseInt(process.env.VUE_APP_COOKIE_EXPIRES || '36000'),
    SameSite: 'Strict'
  },
  tokenDefaultKey: tokenName,
  authRedirect: { path: '/login' },
  loginData: {
    url: "auth/login",
    method: "POST",
    redirect: "/",
    fetchUser: false
  },
  fetchData: {
    url: "auth/me",
    method: "GET",
    enabled: true
  },
  refreshData: {
    url: "auth/refresh_token",
    method: "POST",
    enabled: true,
    transformRequest: function (data) {
      data = JSON.stringify({
        refresh_token: Vue.auth.token(tokenName).split('||')[1]
      });
      return data;
    },
    error: (error) => {
      if (error && error.response) {
        if (error.response.status === 401) {
          const $auth = Vue.auth
          $auth.router.routerGo.call($auth, $auth.options.authRedirect);
        }
      }
    }
  },
  logoutData: {
    url: "auth/logout",
    method: "POST",
    redirect: "/login",
    makeRequest: true,
    transformRequest: function (data) {
      data = JSON.stringify({
        refresh_token: Vue.auth.token(tokenName).split('||')[1]
      });
      return data;
    }
  },
  parseUserData: data => data
});
